export const renderSitecoreData = (data, title) => {
    if (data.sitecoreData) {
        return data.sitecoreData[title];
    }

    return null;
};
